export default "__VITE_ASSET__BIufFo3Z__"